export default __webpack_public_path__ + "static/media/W_wdt_c_cap_1.b6365dc5.mp3";